module.exports = __webpack_public_path__ + "media/src/website/images/locations/tegernsee/profile-66d3570139acef1d18bc3d0709fb1985.jpg";